import { BrowserRouter, Route, Routes } from "react-router-dom";
import Article from "../components/articles/Article";
import LandingPage from "./LandingPage";
import Login from "../components/settings/Login";
import MainDashboard from "../components/settings/MainDashboard";
import EditArticles from "../components/articles/EditArticles";
import ArticleList from "components/articles/ArticleList";
import ContactUs from "components/forms/ContactUs";
import AboutUs from "components/shared/AboutUs";

const Welcome = () => {
  const prefix = "/"; // for prod /temporary/ for local /
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path={prefix + "articles/category/:category"}
            element={<ArticleList />}
          />
          <Route path={prefix + "article/:teamId"} element={<Article />} />
          {/* <Route path={prefix + "contactUs"} element={<ContactUs />} /> */}
          <Route path={prefix + "Dashboard"} element={<MainDashboard />} />
          <Route path={prefix + "EditArticle"} element={<EditArticles />} />
          <Route path={prefix + "settings"} element={<Login />} />
          <Route path={prefix + "contactUs"} element={<AboutUs />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default Welcome;
